import {
  ComponentProps,
  ComponentPropsWithoutRef,
  forwardRef,
  ReactNode
} from 'react';
import { Paragraph } from '../paragraph';
import { Input, Wrapper } from './styled';

export type CheckboxInputProps = {
  text?: ReactNode;
  textSize?: ComponentProps<typeof Paragraph>['variant'];
  disabled?: boolean;
} & ComponentPropsWithoutRef<'input'>;

export const CheckboxInput = forwardRef<HTMLInputElement, CheckboxInputProps>(
  ({ text, textSize, ...props }, ref): JSX.Element => {
    return (
      <Wrapper disabled={props.disabled}>
        <Input type="checkbox" ref={ref} {...props} />
        {typeof text === 'string' && (
          <Paragraph variant={textSize ?? 'small'} span>
            {text}
          </Paragraph>
        )}
      </Wrapper>
    );
  }
);
